/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CopayEntry } from './CopayEntry';
import {
    CopayEntryFromJSON,
    CopayEntryFromJSONTyped,
    CopayEntryToJSON,
} from './CopayEntry';
import type { ValueWithNote } from './ValueWithNote';
import {
    ValueWithNoteFromJSON,
    ValueWithNoteFromJSONTyped,
    ValueWithNoteToJSON,
} from './ValueWithNote';

/**
 * 
 * @export
 * @interface StructuredAnalysisResponseDataCoverageAmounts
 */
export interface StructuredAnalysisResponseDataCoverageAmounts {
    /**
     * 
     * @type {Array<CopayEntry>}
     * @memberof StructuredAnalysisResponseDataCoverageAmounts
     */
    copay?: Array<CopayEntry>;
    /**
     * 
     * @type {ValueWithNote}
     * @memberof StructuredAnalysisResponseDataCoverageAmounts
     */
    out_of_pocket_maximum?: ValueWithNote;
    /**
     * 
     * @type {ValueWithNote}
     * @memberof StructuredAnalysisResponseDataCoverageAmounts
     */
    out_of_pocket_spent?: ValueWithNote;
    /**
     * 
     * @type {ValueWithNote}
     * @memberof StructuredAnalysisResponseDataCoverageAmounts
     */
    out_of_pocket_remaining?: ValueWithNote;
    /**
     * 
     * @type {ValueWithNote}
     * @memberof StructuredAnalysisResponseDataCoverageAmounts
     */
    deductible?: ValueWithNote;
    /**
     * 
     * @type {ValueWithNote}
     * @memberof StructuredAnalysisResponseDataCoverageAmounts
     */
    deductible_spent?: ValueWithNote;
    /**
     * 
     * @type {ValueWithNote}
     * @memberof StructuredAnalysisResponseDataCoverageAmounts
     */
    deductible_remaining?: ValueWithNote;
    /**
     * 
     * @type {ValueWithNote}
     * @memberof StructuredAnalysisResponseDataCoverageAmounts
     */
    coinsurance?: ValueWithNote;
}

/**
 * Check if a given object implements the StructuredAnalysisResponseDataCoverageAmounts interface.
 */
export function instanceOfStructuredAnalysisResponseDataCoverageAmounts(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StructuredAnalysisResponseDataCoverageAmountsFromJSON(json: any): StructuredAnalysisResponseDataCoverageAmounts {
    return StructuredAnalysisResponseDataCoverageAmountsFromJSONTyped(json, false);
}

export function StructuredAnalysisResponseDataCoverageAmountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StructuredAnalysisResponseDataCoverageAmounts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'copay': !exists(json, 'copay') ? undefined : ((json['copay'] as Array<any>).map(CopayEntryFromJSON)),
        'out_of_pocket_maximum': !exists(json, 'out_of_pocket_maximum') ? undefined : ValueWithNoteFromJSON(json['out_of_pocket_maximum']),
        'out_of_pocket_spent': !exists(json, 'out_of_pocket_spent') ? undefined : ValueWithNoteFromJSON(json['out_of_pocket_spent']),
        'out_of_pocket_remaining': !exists(json, 'out_of_pocket_remaining') ? undefined : ValueWithNoteFromJSON(json['out_of_pocket_remaining']),
        'deductible': !exists(json, 'deductible') ? undefined : ValueWithNoteFromJSON(json['deductible']),
        'deductible_spent': !exists(json, 'deductible_spent') ? undefined : ValueWithNoteFromJSON(json['deductible_spent']),
        'deductible_remaining': !exists(json, 'deductible_remaining') ? undefined : ValueWithNoteFromJSON(json['deductible_remaining']),
        'coinsurance': !exists(json, 'coinsurance') ? undefined : ValueWithNoteFromJSON(json['coinsurance']),
    };
}

export function StructuredAnalysisResponseDataCoverageAmountsToJSON(value?: StructuredAnalysisResponseDataCoverageAmounts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'copay': value.copay === undefined ? undefined : ((value.copay as Array<any>).map(CopayEntryToJSON)),
        'out_of_pocket_maximum': ValueWithNoteToJSON(value.out_of_pocket_maximum),
        'out_of_pocket_spent': ValueWithNoteToJSON(value.out_of_pocket_spent),
        'out_of_pocket_remaining': ValueWithNoteToJSON(value.out_of_pocket_remaining),
        'deductible': ValueWithNoteToJSON(value.deductible),
        'deductible_spent': ValueWithNoteToJSON(value.deductible_spent),
        'deductible_remaining': ValueWithNoteToJSON(value.deductible_remaining),
        'coinsurance': ValueWithNoteToJSON(value.coinsurance),
    };
}

